import React from 'react';

import './../styles/embroidery-selector.css'

import Grid from '@mui/material/Unstable_Grid2';
import { TextField } from '@mui/material';

import ColorSwatches from './color-swatches';
import ToggleButtons from './toggle-buttons';
import { CancelIcon } from '../assets/icons/cancel';
import { CheckmarkIcon } from '../assets/icons/checkmark';
import { PlusIcon } from '../assets/icons/plus';
import { MinusIcon } from '../assets/icons/minus';

const TOGGLE_BUTTONS = [
  {
    value: 'NO',
    label1: 'No Embroidery',
    label2: '+ $0.00',
    icon: <CancelIcon />
  },
  {
    value: 'YES',
    label1: 'Add Embroidery',
    label2: '+ $25.00',
    icon: <CheckmarkIcon />
  }
]

const CHAR_LIMIT = 15;

function EmbroiderySelector({
  title,
  price,
  hasEmbroidery,
  setHasEmbroidery,
  isEmbroiderySecondLineVisible,
  setIsEmbroiderySecondLineVisible,
  embroideryText,
  setEmbroideryText,
  embroideryTextSecondLine,
  setEmbroideryTextSecondLine,
  embroideryColors,
  embroideryColor,
  setEmbroideryColor
}) {
  const handleToggleChange = (e) => {
    setHasEmbroidery(e.target.value);
  }
  const handleToggleEmbroiderySecondLineVisibilityChange = (e) => {
    setIsEmbroiderySecondLineVisible(!isEmbroiderySecondLineVisible);
  }
  const handleEmbroideryTextChange = (e) => {
    let text = e.target.value;
    let textFormatted = text.replace(/\s/g, "");

    if (textFormatted?.length <= CHAR_LIMIT) {
      setEmbroideryText(e.target.value);
    }
  }
  const handleEmbroideryTextSecondLineChange = (e) => {
    let text = e.target.value;
    let textFormatted = text.replace(/\s/g, "");

    if (textFormatted?.length <= CHAR_LIMIT) {
      setEmbroideryTextSecondLine(e.target.value);
    }
  }

  return (
    <section className="embroidery-selector-container">
      <Grid container className="embroidery-title-container">
        <Grid item xs={12}>
          <h3 className="embroidery-title">{title}</h3>
          <h3 className="embroidery-price">{price}</h3>
          <p className="embroidery-description">
            Embroidery will be added to the front of the cover above our logo.
          </p>
          <ul className="embroidery-description-list">
            <li>$25.00 for the first 7 characters (letters/numbers/symbols)</li>
            <li>$2.00 per additional character.</li>
            <li>30 character limit (15 characters per line not including spaces)</li>
          </ul>
        </Grid>
      </Grid>
      <Grid container className="embroidery-toggle-container">
        <ToggleButtons
          onChange={handleToggleChange}
          value={hasEmbroidery}
          buttons={TOGGLE_BUTTONS}
        />
      </Grid>
      {hasEmbroidery === "YES" && (
        <Grid container className="embroidery-container">
          <Grid item xs={12}>
            <div className="embroidery-subtitle-container">
              <h5 className="embroidery-subtitle">
                ENTER 1ST LINE OF TEXT
              </h5>
              <button
                className="embroidery-toggle-second-line-button"
                onClick={handleToggleEmbroiderySecondLineVisibilityChange}
              >
                {isEmbroiderySecondLineVisible ? (
                  <MinusIcon />
                ) : (
                  <PlusIcon />
                )}
              </button>
            </div>
            <TextField
              id="embroidery-text"
              className="embroidery-text-field"
              fullWidth
              value={embroideryText}
              onChange={handleEmbroideryTextChange}
              error={embroideryText === ''}
              helperText={embroideryText === '' ? 'This field is required' : ''}
            />
            {isEmbroiderySecondLineVisible && (
              <>
                <h5 className="embroidery-subtitle">
                  ENTER 2ND LINE OF TEXT
                </h5>
                <TextField
                  id="embroidery-text-second-line"
                  className="embroidery-text-field"
                  fullWidth
                  value={embroideryTextSecondLine}
                  onChange={handleEmbroideryTextSecondLineChange}
                  error={isEmbroiderySecondLineVisible && embroideryTextSecondLine === ''}
                  helperText={isEmbroiderySecondLineVisible && embroideryTextSecondLine === '' ? 'This field is required' : ''}
                />
              </>
            )}
          </Grid>
          <Grid item xs={12}>
            <h5 className="embroidery-subtitle">
              Choose thread color: {embroideryColor.name}
            </h5>
            <ColorSwatches
              title=""
              colors={embroideryColors}
              selectedColor={embroideryColor}
              setSelectedColor={setEmbroideryColor}
              className="embroidery-swatches"
            />
          </Grid>
        </Grid>
      )}
    </section>
  )
}

export default EmbroiderySelector
